<script>
  import { slide } from 'svelte/transition';

  export let show;
  export let category;
  export let items = [];

  function handleClick() {
    show = !show;
  }
</script>

{#if show}
  <div class="menu" transition:slide>
    <div class="left">
      {#each items as item}
        <a href={`${category}/${item.slug}#menu`} target="_self" class="link" on:click={handleClick}>{item.name}</a>
      {/each}
    </div>
  </div>
{/if}

<style>
  .menu {
    width: 100%;
    background-color: #000;
    display: grid;
    grid-template-columns: 1fr 1fr;
    font-family: 'Inter', sans-serif;
    font-weight: 400;
    z-index: 11;
  }

  .left {
    padding: 2rem;
  }

  .link {
    display: block;
    padding: 1rem 0;
    color: #fff;
    text-decoration: none;
  }

  .link:hover {
    color: #fff;
    text-decoration: underline;
  }
</style>
